module.exports = __webpack_public_path__ + "img/aParty_111523_D.754ea24b.jpg";